import { TextSelection } from '@tiptap/pm/state';
import { getPrecedingChar, isIn } from './util'; // your existing helpers, etc.

function tryOpenSuggester(params) {
  const {
    view,
    from,
    to,
    typedChar, // e.g. '@', ':', or '/'
    prefix, // e.g. '@' (same as typedChar, but helpful if you do multiple triggers)
    pluginKey,
    parentDenylist,
    allowedPreceding,
  } = params;

  // 1) Check if typedChar matches prefix
  if (typedChar !== prefix) {
    return false; // does not match our trigger
  }

  // 2) Check if current parent is allowed
  if (Array.isArray(parentDenylist) && parentDenylist.length > 0) {
    const $from = view.state.doc.resolve(from);
    if (isIn({ pos: $from, nodeList: parentDenylist })) {
      // e.g. user typed @ in codeBlock
      return false;
    }
  }

  // 3) Check the preceding character(s)
  const precedingChar = getPrecedingChar(view);
  // If you need multiple chars, you could expand your `getPrecedingChar`
  // or match with a bigger chunk. But let's assume one char is enough:
  if (precedingChar !== '' && !precedingChar.match(allowedPreceding ?? /[\s()[\]"':‘’“”]+/)) {
    return false; // preceding char is not valid whitespace or punctuation
  }

  // 4) If everything checks out, dispatch a transaction to open the suggester
  const tr = view.state.tr;

  tr.setMeta(pluginKey, {
    type: 'add',
    pos: from,
  });

  if (from !== to) {
    /**
     * ... and the entire document is to be replaced ...
     */
    if (from === 1 && to === view.state.doc.content.size - 1) {
      /**
       * ... insert a space, this will be after the mention.
       * NOTE: This is caused by YJS.
       */
      tr.replaceSelectionWith(view.state.schema.text(' '));
      tr.setSelection(TextSelection.near(tr.doc.resolve(from - 1), -1));

      /**
       *  ... and only a part of the document is to be replaced ...
       */
    } else {
      tr.deleteSelection();
    }
  }

  view.dispatch(tr);
  return true;
}

export default tryOpenSuggester;
